import SilentModeration from '../../components/SilentModeration';
import React, { Component, Fragment } from 'react';
import { withApollo, Query } from 'react-apollo';
import MessageCard from '../../components/MessageCard';
import {
  GET_MESSAGES,
  CREATE_MESSAGE,
  DELETE_MSG,
  UPDATE_MESSAGE_DETAIL,
} from '../../api/message';
import { GET_CURRENT_USER } from '../../api/user';
import './index.css';
import MessageDetail from '../../components/MessageDetail';
import MessageForm from './MessageForm';
import MessagePost from './MessagePost';
import ModalBox from '../../components/ModalBox';
import Loading from '../../components/Loading';
import { Pagination, Select, Button, message, Empty } from 'antd';
import { withRouter } from 'react-router-dom';
const { Option } = Select;

class MessageFeed extends Component {
  state = {
    operationType: '',
    currentMsgId: '',
    showMessagePost: false,
    searchType: 'content',
    showSelector: false,
    showMessageDetail: false,
    selectedMessages: [],
    keyword: '',
    searchInput: '',
    userHistoryPage: 1,
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.keyword !== prevState.keyword ||
      (!this.state.showSelector && prevState.showSelector)
    ) {
      this._clearSelection();
    }
  }

  _showMessagePost = () => 
    this.setState({ showMessagePost: true });

  _closeMessagePost = () =>
    this.setState({ showMessagePost: false });

  _clearSelection = () =>
    this.setState({ selectedMessages: [], showSelector: false });

  _navigationOnchange = pageNum => {
    this.props.history.push('/message/' + pageNum);
  };

  _toggleSelector = () => {
    const current = this.state.showSelector;
    this.setState({ showSelector: !current });
  };

  _handleSelect = _id => {
    this.setState(({ selectedMessages }) => ({
      selectedMessages: selectedMessages.includes(_id)
        ? selectedMessages.filter(selectedId => selectedId !== _id)
        : selectedMessages.concat(_id),
    }));
  };

  _handleUpdate = (_id, data) => {
    this.props.client
      .mutate({
        mutation: UPDATE_MESSAGE_DETAIL,
        variables: { _id, data },
        refetchQueries: () => [
          {
            query: GET_MESSAGES,
            variables: this._getSearchTerm(),
          },
        ],
      })
      .then(() => message.success('Message updated!'))
      .catch(err => message.error(err.message || 'Error occurred!'));
    this._clearSelection();
    this._onCloseModal();
  };

  _handleDelete = _id => {
    this.props.client
      .mutate({
        mutation: DELETE_MSG,
        variables: { _id },
        refetchQueries: () => [
          {
            query: GET_MESSAGES,
            variables: this._getSearchTerm(),
          },
        ],
      })
      .then(() => message.success('Message deleted!'))
      .catch(err => message.error(err.message || 'Error occurred!'));
    this._clearSelection();
    this._onCloseModal();
  };

  _handleDeleteAll = () => {
    this.state.selectedMessages.map(msgId => this._handleDelete(msgId));
  };

  _getSearchTerm = () => {
    const { searchType, keyword, userHistoryPage } = this.state;
    const { pageNum = 1 } = this.props.match.params;
    return {
      pageSize: keyword && searchType === 'user' ? 15 : keyword ? 100 : 15,
      currentPage: keyword && searchType === 'user' ? userHistoryPage : keyword ? 1 : pageNum * 1,
      ...(keyword && {
        searchTerm: { [searchType]: keyword },
      }),
    };
  };

  _cancelSearch = () => this.setState({ keyword: '', searchInput: '', userHistoryPage: 1 });

  _showUserHistory = userId => {
    this.setState({
      searchType: 'user',
      keyword: userId,
      searchInput: userId,
      userHistoryPage: 1,
      selectedMessages: [],
      showSelector: false,
      currentMsgId: '',
      operationType: '',
      showMessageDetail: false,
    });
  };

  _onCloseModal = () => {
    this.setState({
      currentMsgId: '',
      operationType: '',
      showMessageDetail: false,
    });
  };

  _handleButtonClick = (_id, type) => {
    this.setState({
      currentMsgId: _id,
      operationType: type,
    });
  };

  _createMessage = () => {
    const { form } = this.msgRef.props;
    form.validateFields((err, values) => {
      let userId = '5fd63bfeac72383eedf9a8bd';
      let display = {
        gender: false,
        grade: false,
        major: false
      }
      if (values.user === '某男生') {
        userId = '5fd63c16ac72383eedf9a8be';
        display.gender = true;
      }
      if (values.user === '某女生') {
        userId = '5fd63c35ac72383eedf9a8bf';
        display.gender = true;
      }
      const msg = {
        user: userId,
        content: values.content,
        isAnom: true,
        school: '广西大学',
        display
      };
      this.props.client
        .mutate({
          mutation: CREATE_MESSAGE,
          variables: {
            data: msg
          },
          refetchQueries: () => [
            {
              query: GET_MESSAGES,
              variables: this._getSearchTerm(),
            },
          ]
        })
        .then(() => {
          message.success('发布成功!');
          this._closeMessagePost();
        })
        .catch(err => message.error(err.message || '未知错误!'));
    });
  };

  _handleSubmit = () => {
    const { selectedMessages, currentMsgId, operationType } = this.state;
    if (selectedMessages.length && operationType === 'Delete')
      return this._handleDeleteAll();
    const { form } = this.formRef.props;
    form.validateFields((err, values) => {
      if (err) return;
      if (operationType === 'Delete') {
        //delete message
        this._handleDelete(currentMsgId); // delete signle message with reason
      } else {
        //edit message
        this._handleUpdate(currentMsgId, values);
      }
    });
  };

  setRef = ref => {
    this.formRef = ref;
  };

  _toggleDetails = _id => {
    this.setState(({ showMessageDetail }) => ({
      showMessageDetail: !showMessageDetail,
      currentMsgId: _id,
    }));
  };

  render() {
    const { pageNum = 1 } = this.props.match.params;
    const {
      keyword,
      searchInput,
      userHistoryPage,
      searchType,
      showSelector,
      selectedMessages,
      showMessageDetail,
      currentMsgId,
      operationType,
      showMessagePost
    } = this.state;

    const isUserHistory = searchType === 'user' && !!keyword;

    return (
      <Query query={GET_CURRENT_USER}>
        {({ data: { currentUser } }) => {
          const isAdmin = currentUser.role === 'admin';
          return (
            <div className="list-area">
              <div className="message-top-buttons">
                <div className="aligner">
                  <input
                    placeholder={searchType === 'user' ? '输入用户 ID' : 'Search for a message'}
                    value={searchInput}
                    onChange={event => this.setState({ searchInput: event.target.value })}
                    className="search-input"
                    onKeyDown={e => {
                      if (e.key === 'Enter')
                        this.setState({ keyword: e.target.value.trim(), userHistoryPage: 1 });
                    }}
                  />

                  {isAdmin &&
                    <Select
                      style={{ marginRight: '8px' }}
                      onChange={type => this.setState({ searchType: type, keyword: '', searchInput: '', userHistoryPage: 1 })}
                      value={searchType}
                    >
                      <Option value="_id">_id</Option>
                      <Option value="content">content</Option>
                      <Option value="user">用户 ID</Option>
                    </Select>
                  }

                  {keyword && (
                    <Button
                      className="message-top-button"
                      icon="close"
                      type="danger"
                      shape="circle"
                      onClick={this._cancelSearch}
                    />
                  )}
                </div>

                <div className="aligner">
                  <Button
                    className="message-top-button"
                    onClick={this._toggleSelector}
                  >
                    {showSelector ? 'Hide' : 'Select'}
                  </Button>

                  {isAdmin && selectedMessages.length > 0 && (
                    <SilentModeration ids={selectedMessages} onDone={this._clearSelection} />
                  )}
                  {selectedMessages.length > 1 && (
                    <Button
                      className="message-top-button"
                      icon="delete"
                      type="danger"
                      onClick={() => this.setState({ operationType: 'Delete' })}
                    >
                      Delete all
                    </Button>
                  )}
                </div>
              </div>
              {isUserHistory && <p>发帖历史 · 用户 ID <code>{keyword}</code></p>}
              <Query query={GET_MESSAGES} variables={this._getSearchTerm()}>
                {({ loading, error, data }) => {
                  if (loading) return <Loading />;
                  if (error) return <p>Error!</p>;
                  const { messages = [] } = data;
                  return messages.length || isUserHistory ? (
                    <Fragment>
                      {isUserHistory ? <p>第 {userHistoryPage} 页 · 本页 {messages.length} 条</p> : <p>Found {messages.length} matches</p>}
                      {!messages.length && <Empty className="empty-hint" description="本页没有纸条" />}
                      <div className="message-feed">
                        {messages.map(msg => (
                          <MessageCard
                            showEdit={isAdmin}
                            key={msg._id}
                            message={msg}
                            onPress={this._handleButtonClick}
                            onSelect={this._handleSelect}
                            showDetails={this._toggleDetails}
                            showSelector={showSelector}
                            checked={selectedMessages.includes(msg._id)}
                          />
                        ))}
                      </div>
                      {isUserHistory ? (
                        <div className="message-top-buttons">
                          <Button disabled={userHistoryPage <= 1} onClick={() =>
                            this.setState({ userHistoryPage: userHistoryPage - 1 })}>上一页</Button>
                          <Button disabled={messages.length < 15} onClick={() =>
                            this.setState({ userHistoryPage: userHistoryPage + 1 })}>下一页</Button>
                        </div>
                      ) : (
                        <Pagination showQuickJumper defaultCurrent={pageNum * 1}
                          total={500} onChange={this._navigationOnchange} />
                      )}
                    </Fragment>
                  ) : (
                    <Empty className="empty-hint" />
                  );
                }}
              </Query>

              <ModalBox
                visible={showMessageDetail}
                title="纸条详情"
                hideFooter
                onCancel={this._onCloseModal}
              >
                <MessageDetail key={currentMsgId} _id={currentMsgId} onViewUserHistory={this._showUserHistory} />
              </ModalBox>

              <ModalBox
                visible={!!operationType}
                title={`${operationType} message (id: ${currentMsgId})`}
                onConfirm={this._handleSubmit}
                onCancel={this._onCloseModal}
              >
                <MessageForm
                  operationType={operationType}
                  onSubmit={this._handleSubmit}
                  onSetRef={this.setRef}
                  _id={currentMsgId}
                />

                <p style={{ fontWeight: '500', color: '#D80F15' }}>
                  Are you sure you want to proceed?
                </p>
              </ModalBox>
            </div>
          )
        }}
      </Query>
    );
  }
}

export default withApollo(withRouter(MessageFeed));
